/*
  Barra fija de compra + «Leer más» (R3, 11-oct-2026). Sin dependencias.
  - La barra nunca hace su propio /cart/add: pulsa el botón de envío del
    formulario principal (ProductSubmitButton-<sección>), así el cajón del
    carrito, los avisos y la medición son exactamente los de hoy.
  - Fuente de verdad: el DOM de la ficha (botón, input name="id", JSON
    data-selected-variant del selector y caja de precio). Se relee siempre,
    porque product-info.js sustituye el selector en cada cambio de variante.
  - Nunca añade una variante que el cliente no eligió: con varias opciones,
    basta con que haya tocado UNA (la combinación que ve en la ficha cuenta
    como elegida, también la que el tema marca sola; Francisco, 11-oct
    15:37Z) o que haya llegado con ?variant=.
  - Precio y texto del botón se copian de la ficha (promoción incluida).
*/
(() => {
  if (customElements.get('sticky-atc')) return;

  // Flotantes de base.css que deben subir por encima de la barra
  const FLOTANTES = '.rbchat-floating-button, .whatsapp-float, .recambios-chat-fallback, .jdgm-popup-widget__cards-container';
  // Paneles que tapan la barra (misma lista que base.css y sticky-atc.css). Con uno abierto
  // la barra de pago móvil está oculta: NO se mide el hueco (se mide al cerrarse)
  const PANELES = [
    'cart-drawer.active', '.cart-upsell-modal[open]', 'modal-dialog[open]', 'product-modal[open]',
    'quick-add-modal[open]', 'pickup-availability-drawer[open]', '.cart-notification.active',
    'header-drawer > details[open]', 'details-modal > details[open]', '.mobile-facets__wrapper > details[open]',
    "localization-form [aria-expanded='true']", '[data-express-modal]:not([hidden])',
    "#shopify-pc__banner[style*='display: block']", "#shopify-pc__prefs[style*='display: block']",
  ].join(', ');
  // Elementos cuyas clases/estilos cambian al abrir o cerrar paneles y flotantes
  const VIGILADOS = `cart-drawer, .cart-notification, .cart-upsell-modal, modal-dialog, product-modal, quick-add-modal, pickup-availability-drawer, header-drawer > details, details-modal > details, [data-express-modal], #shopify-pc__banner, #shopify-pc__prefs, .barra-pago-movil, ${FLOTANTES}`;
  // Señales de datos de compatibilidad (texto sin tildes y en minúsculas)
  // (compatible, válido para, apto, fits, passend für, modelos, chasis, serie, motorización, OEM, VIN,
  //  chasis E90/F30/G20/U11, MINI R56, Motorrad K25, motores N47/B48, modelos 320d/118i/M340i, X5/M3...)
  const COMPAT = new RegExp(
    [
      'compatib', 'kompatib', 'compativ', '\\bmodel', '\\bchass?is\\b', 'fahrgestell', 'telaio', 'bastidor', 'baureihe',
      '\\bseries?\\b', 'motoriza', 'motorisa', '\\boem\\b', '\\bvin\\b',
      'valid[oa]s? para', 'valable', 'valido per', '\\bfits?\\b', 'suitable', 'passend', 'geeignet', 'adatt', 'convient',
      'aplicaci', '\\bapt[oa]s? (?:para|per) (?:bmw|mini|tu|su|el|todos|todas|motos?|coches?|vehiculos?)',
      '\\b[efgkru]\\d{2}\\b', '\\b[nmsb]\\d{2}[a-z]?\\d{0,2}\\b', '\\b[ixzm]\\d\\b',
      '\\b[1-8]\\d{2}(?:[deil]|xd|xi|li|sd|si|ci|td|tds|is)\\b', '\\bm\\d{3}[a-z]{0,2}\\b',
    ].join('|')
  );

  const sinTildes = (t) => (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const menosMovimiento = () => !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hayPubSub = () => typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object';
  const texto = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
  // Carrito → {id de variante: {clave, cantidad}} (la primera línea de cada variante)
  const lineasDe = (carrito) => {
    const m = new Map();
    ((carrito && carrito.items) || []).forEach((it) => {
      const k = String(it.variant_id);
      if (!m.has(k)) m.set(k, { clave: it.key, cantidad: Number(it.quantity) || 0 });
    });
    return m;
  };

  // Estado común en <body> (puede haber dos instancias un instante al cambiar de producto)
  const instancias = new Set();
  function pintarBody() {
    const body = document.body;
    let lista = false;
    let visible = false;
    let alto = 0;
    let elevar = 0;
    instancias.forEach((i) => {
      if (!i.barraLista) return;
      lista = true;
      alto = Math.max(alto, i.alto || 0);
      if (i.visible) {
        visible = true;
        elevar = Math.max(elevar, i.elevar || 0);
      }
    });
    if (body.classList.contains('sticky-atc-ready') !== lista) body.classList.toggle('sticky-atc-ready', lista);
    if (body.classList.contains('sticky-atc-visible') !== visible) body.classList.toggle('sticky-atc-visible', visible);
    // solo se escribe si cambia: el body se vigila para volver a medir el hueco
    const poner = (prop, valor) => {
      if (body.style.getPropertyValue(prop) === (valor || '')) return;
      if (valor) body.style.setProperty(prop, valor);
      else body.style.removeProperty(prop);
    };
    poner('--sticky-atc-height', lista ? `${alto}px` : '');
    poner('--sticky-atc-lift', visible ? `${elevar}px` : '');
  }

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.sid = this.dataset.section;
      this.limpiezas = [];
      this.hidden = false;
      instancias.add(this);
      const lineas = parseInt(this.dataset.readMoreLines, 10) || 0;
      if (lineas > 0) this.iniciarLeerMas(lineas);
      if (this.dataset.bar === 'true') this.iniciarBarra();
    }

    disconnectedCallback() {
      this.limpiezas.forEach((fn) => {
        try {
          fn();
        } catch (e) {
          /* nada */
        }
      });
      this.limpiezas = [];
      instancias.delete(this);
      if (!instancias.size) {
        document.querySelectorAll('[data-sticky-atc-lift]').forEach((el) => el.removeAttribute('data-sticky-atc-lift'));
      }
      pintarBody();
    }

    // ---- elementos de la ficha (se buscan cada vez: el tema los sustituye) ----
    get botonPrincipal() {
      return document.getElementById(`ProductSubmitButton-${this.sid}`);
    }
    get formulario() {
      return document.getElementById(`product-form-${this.sid}`);
    }
    get selector() {
      return document.getElementById(`variant-selects-${this.sid}`);
    }
    get cajaPrecio() {
      return document.getElementById(`price-${this.sid}`);
    }
    get columnaInfo() {
      return document.getElementById(`ProductInfo-${this.sid}`);
    }

    escuchar(objetivo, evento, fn, opciones) {
      objetivo.addEventListener(evento, fn, opciones);
      this.limpiezas.push(() => objetivo.removeEventListener(evento, fn, opciones));
    }

    // =====================================================================
    // Barra
    // =====================================================================
    iniciarBarra() {
      this.barra = this.querySelector('.sticky-atc__bar');
      this.btn = this.querySelector('.sticky-atc__button');
      this.etiqueta = this.querySelector('.sticky-atc__label');
      this.giro = this.btn && this.btn.querySelector('.loading__spinner');
      this.txtVariante = this.querySelector('.sticky-atc__variant');
      this.txtPrecio = this.querySelector('.sticky-atc__price');
      this.chips = Array.from(this.querySelectorAll('.sticky-atc__option'));
      this.conVariantes = this.dataset.hasVariants === 'true';
      // Si llegó con ?variant= (p. ej. Google Shopping) ya eligió; si no, tiene que tocar
      // al menos UNA opción (índices de grupo tocados: «Elegir opción» lleva a la primera sin tocar)
      this.preseleccionada = this.dataset.preselected === 'true';
      this.tocadas = new Set();
      this.algunaTocada = false;
      this.pendiente = false;
      this.pasado = false;
      this.visible = false;

      if (!this.barra || !this.btn || !this.botonPrincipal || !('IntersectionObserver' in window)) return;
      // Si el CSS no cargó, mejor sin barra que una barra suelta en la página
      if (getComputedStyle(this.barra).position !== 'fixed') {
        this.hidden = true;
        return;
      }

      this.escuchar(this, 'click', (ev) => {
        const chip = ev.target.closest('.sticky-atc__option');
        if (chip) return this.alPulsarOpcion(chip);
        if (ev.target.closest('.sticky-atc__button')) this.alPulsarBoton();
      });
      this.escuchar(this, 'focusout', () => setTimeout(() => this.programar(), 0));
      this.escuchar(document, 'focusin', (ev) => {
        const v = this.volverA;
        if (!v || Date.now() > v.hasta || !this.selector || !this.selector.contains(ev.target)) return;
        this.volverA = null;
        requestAnimationFrame(() => {
          window.scrollTo({ top: v.y, behavior: 'auto' });
          if (v.chip.isConnected) v.chip.focus({ preventScroll: true });
        });
      });

      // Interacción REAL del cliente con el selector principal => ya ha elegido
      this.escuchar(document, 'change', (ev) => this.alCambiarEnFicha(ev));
      this.escuchar(document, 'click', (ev) => {
        const sel = this.selector;
        if (ev.isTrusted && sel && sel.contains(ev.target) && ev.target.matches('input[type="radio"]')) {
          this.marcarTocada(ev.target);
        }
      });
      // Desplegable: abrirlo y cerrarlo dejando el valor también cuenta como elegir
      this.escuchar(document, 'pointerdown', (ev) => this.tocarDesplegable(ev));
      this.escuchar(document, 'keydown', (ev) => {
        if (ev.key !== 'Tab' && ev.key !== 'Shift') this.tocarDesplegable(ev);
      });
      this.escuchar(document, 'focusout', (ev) => {
        if (ev.target && ev.target.dataset && ev.target.dataset.stickyAtcTocado) {
          delete ev.target.dataset.stickyAtcTocado;
          if (this.selector && this.selector.contains(ev.target)) this.marcarTocada(ev.target);
        }
      });

      if (hayPubSub()) {
        const fuera = [
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data } = {}) => {
            const ev = data && data.event;
            if (!ev || !this.selector || !this.selector.contains(ev.target)) return;
            if (ev.isTrusted) this.marcarTocada(ev.target);
            this.marcarPendiente();
          }),
          subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
            if (data && data.sectionId && data.sectionId !== this.sid) return;
            this.pendiente = false;
            // el foco de product-info.js llega justo después de este aviso
            setTimeout(() => {
              this.volverA = null;
            }, 0);
            this.programar();
          }),
          subscribe(PUB_SUB_EVENTS.cartError, () => {
            // Error al añadir desde la barra: llevar al cliente al aviso del formulario
            if (this.ultimoEnvio && Date.now() - this.ultimoEnvio < 15000) {
              const zona = this.formulario && this.formulario.closest('product-form');
              if (zona) this.desplazarA(zona);
            }
          }),
          subscribe(PUB_SUB_EVENTS.cartUpdate, (datos) => {
            this.tomarDatosCarrito(datos);
            this.remedir();
            this.leerCarrito();
          }),
        ];
        this.limpiezas.push(() => fuera.forEach((f) => typeof f === 'function' && f()));
      }

      // Aparece cuando NINGÚN trozo del bloque de compra (precio, opciones, cantidad y botones) está en
      // pantalla, por encima o por debajo; con un trozo a la vista, aunque sea pequeño, se esconde
      // (Francisco, 11-oct 15:51Z). this.pasado = «bloque fuera de la pantalla». El observador solo avisa:
      // el estado se calcula siempre con bloqueFuera() sobre todas las piezas a la vez
      this.io = new IntersectionObserver(() => {
        this.pasado = this.bloqueFuera();
        this.programar();
      });
      this.limpiezas.push(() => this.io.disconnect());
      this.limpiezas.push(() => this.quitarResalte());

      // Red de seguridad: cambios en botón, precio o selector sin evento
      this.mo = new MutationObserver(() => this.programar());
      this.limpiezas.push(() => this.mo.disconnect());
      this.vigilar();

      // Hueco inferior (barra de pago móvil): se vuelve a medir cuando cambian las clases o
      // estilos del body, del cajón, avisos, modales, cookies, barra de pago o flotantes,
      // cuando llegan flotantes nuevos (el chat se inyecta después) y al hacer scroll o resize
      this.moPaneles = new MutationObserver(() => this.remedir());
      this.limpiezas.push(() => this.moPaneles.disconnect());
      this.moBody = new MutationObserver(() => {
        this.vigilarPaneles();
        this.remedir();
        if (this.visible) this.marcarFlotantes();
      });
      this.moBody.observe(document.body, { childList: true, attributes: true, attributeFilter: ['class', 'style'] });
      this.limpiezas.push(() => this.moBody.disconnect());
      this.vigilarPaneles();
      this.limpiezas.push(() => {
        clearTimeout(this.tRemedir);
        clearTimeout(this.tPendiente);
        clearTimeout(this.tCargando);
        cancelAnimationFrame(this.rafMedir);
      });

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.medir());
        this.ro.observe(this.barra);
        this.limpiezas.push(() => this.ro.disconnect());
      }
      // Scroll y resize: (1) si la barra se ve, volver a medir el hueco; (2) volver a mirar si el bloque
      // de compra está fuera de la pantalla: un salto (ancla, volver atrás, scroll rápido) que lo lleva
      // de un lado a otro sin cruzarla NO avisa al IntersectionObserver
      const revisarBloque = () => {
        if (this.rafPasado) return;
        this.rafPasado = requestAnimationFrame(() => {
          this.rafPasado = 0;
          if (!this.isConnected) return;
          const pasado = this.bloqueFuera();
          if (pasado !== this.pasado) {
            this.pasado = pasado;
            this.programar();
          }
        });
      };
      this.escuchar(window, 'resize', () => {
        this.remedir();
        revisarBloque();
      });
      this.escuchar(
        window,
        'scroll',
        () => {
          if (this.visible) this.remedir();
          revisarBloque();
        },
        { passive: true }
      );
      this.limpiezas.push(() => cancelAnimationFrame(this.rafPasado));

      // [−] cantidad [+] en lugar de «Añadir» cuando la variante que se compraría ya está en el carrito (Francisco, 11-oct 17:24Z)
      this.lineas = null;
      this.crearCantidad();
      this.leerCarrito();
      // Al volver a la ficha con «atrás» (Safari la devuelve de memoria, tal como estaba) o a la pestaña, el carrito
      // puede haber cambiado: se relee
      this.escuchar(window, 'pageshow', (ev) => {
        if (ev.persisted) this.leerCarrito();
      });
      this.escuchar(document, 'visibilitychange', () => {
        if (document.visibilityState === 'visible') this.leerCarrito();
      });

      this.barraLista = true;
      this.pasado = this.bloqueFuera();
      this.medir();
      this.refrescar();
    }

    // Piezas del bloque de compra que se miran para decidir si la barra sale
    piezasBloque() {
      const compra = this.formulario && this.formulario.closest('product-form');
      return [this.cajaPrecio, this.selector, document.getElementById(`Quantity-Form-${this.sid}`), compra, this.botonPrincipal].filter(
        Boolean
      );
    }

    // ¿Está TODO el bloque de compra fuera de la pantalla (por arriba o por abajo)? Las piezas ocultas
    // (tamaño cero) no cuentan; sin ninguna pieza medible, no hay barra
    bloqueFuera() {
      let arriba = Infinity;
      let abajo = -Infinity;
      this.piezasBloque().forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.height <= 0 || r.width <= 0) return;
        arriba = Math.min(arriba, r.top);
        abajo = Math.max(abajo, r.bottom);
      });
      if (abajo === -Infinity) return false;
      return abajo <= 0 || arriba >= window.innerHeight;
    }

    vigilar() {
      const boton = this.botonPrincipal;
      if (boton && boton !== this.botonVigilado) {
        if (this.botonVigilado) this.io.unobserve(this.botonVigilado);
        this.botonVigilado = boton;
        this.io.observe(boton);
        this.mo.observe(boton, {
          attributes: true,
          attributeFilter: ['disabled', 'class', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
      if (!this.ioVigilados) this.ioVigilados = new WeakSet();
      this.piezasBloque().forEach((el) => {
        if (this.ioVigilados.has(el)) return;
        this.ioVigilados.add(el);
        this.io.observe(el);
      });
      const precio = this.cajaPrecio;
      if (precio && precio !== this.precioVigilado) {
        this.precioVigilado = precio;
        this.mo.observe(precio, { attributes: true, childList: true, subtree: true, characterData: true });
      }
      const columna = this.columnaInfo;
      if (columna && columna !== this.columnaVigilada) {
        this.columnaVigilada = columna;
        this.mo.observe(columna, { childList: true });
      }
      // Bloque de promoción del tema («Precio final»): su JS lo rellena después del precio
      const promo = this.zonaPromo();
      if (promo && promo !== this.promoVigilada) {
        this.promoVigilada = promo;
        this.mo.observe(promo, { childList: true, subtree: true, characterData: true, attributes: true });
      }
    }

    vigilarPaneles() {
      if (!this.panelesVigilados) this.panelesVigilados = new WeakSet();
      document.querySelectorAll(VIGILADOS).forEach((el) => {
        if (this.panelesVigilados.has(el)) return;
        this.panelesVigilados.add(el);
        this.moPaneles.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-expanded'] });
      });
    }

    // Mide en el próximo fotograma y otra vez al rato (paneles y barras que se animan)
    remedir() {
      if (!this.barraLista) return;
      if (!this.rafMedir) {
        this.rafMedir = requestAnimationFrame(() => {
          this.rafMedir = 0;
          if (this.isConnected) this.medir();
        });
      }
      clearTimeout(this.tRemedir);
      this.tRemedir = setTimeout(() => this.isConnected && this.medir(), 450);
    }

    // ---- elección por opción ----
    // ¿Elegida? Sin variantes, con ?variant= o en cuanto el cliente ha tocado UNA opción: lo que ve
    // en la ficha (también la 2.ª opción que el tema marca sola al cambiar la 1.ª) cuenta como elegido
    get elegido() {
      if (!this.conVariantes || this.preseleccionada) return true;
      return this.algunaTocada;
    }

    grupos() {
      const sel = this.selector;
      return sel ? Array.from(sel.querySelectorAll('.product-form__input')) : [];
    }

    // Grupos de opción con más de un valor que el cliente aún no ha tocado, en orden (lista vacía si ninguno)
    opcionesSinTocar() {
      const sel = this.selector;
      if (!sel) return [];
      const grupos = this.grupos();
      // Selector sin grupos reconocibles: basta con que haya tocado algo (como antes)
      if (!grupos.length) return this.algunaTocada ? [] : [sel];
      return grupos.filter((g, i) => !this.tocadas.has(i) && g.querySelectorAll('option, input[type="radio"]').length > 1);
    }

    marcarTocada(el) {
      const sel = this.selector;
      if (!el || !sel || !sel.contains(el)) return;
      const grupo = el.closest('.product-form__input');
      const i = grupo ? this.grupos().indexOf(grupo) : -1;
      const nueva = !this.algunaTocada || (i >= 0 && !this.tocadas.has(i));
      this.algunaTocada = true;
      if (i >= 0) this.tocadas.add(i);
      if (i >= 0) this.quitarResalte(i);
      if (nueva) this.programar();
    }

    alCambiarEnFicha(ev) {
      const t = ev.target;
      if (!t || !t.matches) return;
      const sel = this.selector;
      if (sel && sel.contains(t)) {
        if (ev.isTrusted) this.marcarTocada(t);
        return;
      }
      // product-info.js actualiza el input del formulario; vacío = combinación inexistente
      // getAttribute: form.id devolvería el <input name="id">
      if (t.matches('input[name="id"]') && t.form && t.form.getAttribute('id') === `product-form-${this.sid}`) {
        if (!t.value) this.pendiente = false;
        this.programar();
      }
    }

    tocarDesplegable(ev) {
      const sel = this.selector;
      if (ev.isTrusted && sel && ev.target && ev.target.tagName === 'SELECT' && sel.contains(ev.target)) {
        ev.target.dataset.stickyAtcTocado = '1';
      }
    }

    marcarPendiente() {
      this.pendiente = true;
      this.desdePendiente = Date.now();
      clearTimeout(this.tPendiente);
      clearTimeout(this.tCargando);
      // Si tarda, la barra dice «Cargando…» con el botón desactivado (nunca la variante anterior)
      this.tCargando = setTimeout(() => this.programar(), 350);
      // Si la respuesta no llega nunca, se suelta la espera: «Elegir opción» lleva al selector
      this.tPendiente = setTimeout(() => {
        this.pendiente = false;
        this.programar();
      }, 20000);
      this.programar();
    }

    programar() {
      if (this.rafPendiente) return;
      this.rafPendiente = requestAnimationFrame(() => {
        this.rafPendiente = 0;
        if (this.isConnected) this.refrescar();
      });
    }

    // Copia de lo que enseña la caja de precio de la ficha (y el «Precio final» de la promoción)
    leerPrecio() {
      const caja = this.cajaPrecio;
      if (!caja || caja.classList.contains('hidden')) return null;
      const p = caja.querySelector('.price');
      if (!p) return null;
      let precio;
      if (p.classList.contains('price--on-sale')) {
        precio = {
          ahora: texto(p.querySelector('.price__sale .price-item--sale')),
          antes: texto(p.querySelector('.price__sale s.price-item--regular')),
        };
      } else {
        precio = { ahora: texto(p.querySelector('.price__regular .price-item--regular')) };
      }
      const promo = this.leerPromo();
      if (promo) precio.promo = promo;
      return precio;
    }

    zonaPromo() {
      const valor = document.getElementById('final-discounted-price');
      const zona = valor && valor.closest('.custom-discount-display');
      const ficha = document.getElementById(`MainProduct-${this.sid}`);
      return zona && (!ficha || ficha.contains(zona)) ? zona : null;
    }

    // «Precio final: X» del bloque de promoción del tema, solo si se ve y ya tiene un importe
    leerPromo() {
      const zona = this.zonaPromo();
      if (!zona || !zona.getClientRects().length) return null;
      const valor = texto(document.getElementById('final-discounted-price'));
      if (!/\d/.test(valor)) return null;
      return { etiqueta: texto(document.getElementById('final-price-label')), valor };
    }

    // El MISMO texto que el botón de la ficha (p. ej. «Agregar al carrito con el descuento»)
    textoAnadir(est) {
      const b = est.boton;
      if (b && !b.disabled && !est.cargando) {
        const t = texto(b.querySelector('span'));
        if (t) this.ultimoTextoAnadir = t;
      }
      return this.ultimoTextoAnadir || this.dataset.textAdd || '';
    }

    leerEstado() {
      const boton = this.botonPrincipal;
      const form = this.formulario;
      const input = form && form.querySelector('input[name="id"]');
      const id = input ? String(input.value || '') : '';
      let variante = null;
      const json = this.selector && this.selector.querySelector('[data-selected-variant]');
      if (json) {
        try {
          variante = JSON.parse(json.textContent);
        } catch (e) {
          variante = null;
        }
      }
      // cargando = envío en curso (ruedita); bloqueado = el tema tiene el botón en espera
      const cargando = !!boton && boton.classList.contains('loading');
      const bloqueado = !!boton && boton.getAttribute('aria-disabled') === 'true';
      // ¿Lo marcado en el selector es ya lo que ha pintado el tema? (si no, sigue cargando)
      let coherente = true;
      if (variante && Array.isArray(variante.options)) {
        const grupos = this.grupos();
        if (grupos.length === variante.options.length) {
          coherente = grupos.every((g, i) => {
            const s = g.querySelector('select');
            const r = g.querySelector('input[type="radio"]:checked');
            const v = s ? s.value : r ? r.value : null;
            return v === null || v === variante.options[i];
          });
        }
      }
      // Comprable solo si botón activo, hay id y coincide con la variante del selector
      const coincide = !variante || String(variante.id) === id;
      const comprable =
        !!boton && !boton.disabled && !!id && coincide && coherente && (!variante || variante.available !== false);
      return { boton, id, variante, cargando, bloqueado, comprable, coincide, coherente };
    }

    calcularModo(est) {
      if (!est.boton) return 'off';
      if (!this.conVariantes) return est.comprable ? 'add' : 'off';
      return this.elegido && est.comprable ? 'add' : 'choose';
    }

    refrescar() {
      if (!this.barraLista) return;
      this.vigilar();
      const est = this.leerEstado();
      // La respuesta del tema ya está pintada: se acaba la espera
      if (this.pendiente && est.coherente && !est.bloqueado && Date.now() - this.desdePendiente > 50) {
        const sel = this.selector;
        if (!sel || !sel.querySelector('[aria-busy="true"]')) this.pendiente = false;
      }
      const ocupado = this.pendiente || est.cargando || est.bloqueado;
      let modo = this.calcularModo(est);
      // Mientras el tema recalcula la variante, se mantiene la etiqueta anterior
      if (this.pendiente && this.modo && modo !== 'off') modo = this.modo;
      this.modo = modo;

      // Texto: variante + precio. Los primeros 300 ms de espera se deja el anterior (sin parpadeo);
      // si tarda más, «Cargando…»
      const enEspera = this.pendiente && Date.now() - this.desdePendiente < 300;
      if (!enEspera) {
        let variante = '';
        let precio = null;
        const elegido = this.elegido;
        if (this.pendiente) {
          variante = this.dataset.textLoading || '';
        } else if (!this.conVariantes) {
          precio = this.leerPrecio();
        } else if (!elegido || !est.coherente) {
          variante = this.dataset.textHint || '';
          // mismo precio que la ficha si no varía entre variantes; si varía, «A partir de…»
          const ref = { ahora: this.dataset.priceRef || '' };
          precio = elegido || this.dataset.priceVaries === 'true' ? ref : this.leerPrecio() || ref;
        } else if (!est.variante || !est.id) {
          variante = this.dataset.textUnavailable || '';
        } else {
          variante = est.variante.title || '';
          if (est.variante.available === false) variante += ` · ${this.dataset.textSoldOut || ''}`;
          precio = this.leerPrecio();
        }
        this.pintarTexto(variante, precio);
      }

      // Botón: en «añadir», el mismo texto que el botón de la ficha
      this.setEtiqueta(modo === 'add' ? this.textoAnadir(est) : this.dataset.textChoose);
      if (ocupado) {
        this.btn.setAttribute('aria-disabled', 'true');
        this.btn.setAttribute('aria-busy', 'true');
      } else {
        this.btn.removeAttribute('aria-disabled');
        this.btn.removeAttribute('aria-busy');
      }
      this.btn.classList.toggle('loading', est.cargando);
      if (this.giro) this.giro.classList.toggle('hidden', !est.cargando);
      this.dataset.modo = modo;
      // ¿La variante que se compraría ya está en el carrito? Entonces [−] cantidad [+] (solo en «añadir»: nunca para una
      // variante sin elegir)
      const enCarrito = modo === 'add' && est.id && this.lineas ? this.lineas.get(String(est.id)) : null;
      this.pintarCantidad(enCarrito, ocupado);

      // Opciones en la barra: reflejan la elección del cliente (nada marcado si no eligió)
      if (this.chips.length) {
        const actual = this.elegido ? this.valorPrincipal() : null;
        this.chips.forEach((c) => {
          const si = actual !== null && c.dataset.optionValueId === actual;
          if (c.getAttribute('aria-pressed') !== String(si)) c.setAttribute('aria-pressed', String(si));
        });
      }

      // Visibilidad (si el foco está dentro, no se esconde bajo el cliente).
      // Si el botón de la ficha está oculto (tamaño cero), no hay barra
      const conFoco = this.contains(document.activeElement);
      const botonVisible = !!est.boton && est.boton.getClientRects().length > 0 && est.boton.offsetHeight > 0;
      this.mostrar(modo !== 'off' && botonVisible && (this.pasado || (this.visible && conFoco)));
    }

    crearCantidad() {
      const caja = document.createElement('div');
      caja.className = 'sticky-atc__qty sticky-atc__oculto';
      caja.setAttribute('role', 'group');
      caja.setAttribute('aria-label', this.dataset.textQtyLabel || '');
      const boton = (paso, etiqueta, signo) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'sticky-atc__qty-btn';
        b.dataset.paso = paso;
        b.setAttribute('aria-label', etiqueta || '');
        b.textContent = signo;
        return b;
      };
      this.qtyMenos = boton('-1', this.dataset.textQtyMinus, '−');
      this.qtyNum = document.createElement('span');
      this.qtyNum.className = 'sticky-atc__qty-num';
      this.qtyNum.setAttribute('aria-live', 'polite');
      this.qtyMas = boton('1', this.dataset.textQtyPlus, '+');
      caja.append(this.qtyMenos, this.qtyNum, this.qtyMas);
      this.qtyAviso = document.createElement('span');
      this.qtyAviso.className = 'sticky-atc__qty-aviso';
      this.qtyAviso.setAttribute('role', 'status');
      this.btn.after(caja, this.qtyAviso);
      this.cajaCantidad = caja;
      this.escuchar(caja, 'click', (ev) => {
        const b = ev.target.closest('[data-paso]');
        if (b && !b.disabled) this.cambiarCantidad(Number(b.dataset.paso));
      });
    }

    // Lo que trae el aviso del carrito se pinta YA, sin esperar a releer /cart.js (Francisco, 11-oct 19:57Z: en el
    // iPhone, tras añadir, la barra seguía con «Añadir» hasta recargar): el formulario de la ficha manda la línea
    // añadida (variant_id, key y cantidad total de esa línea); la barra y el carrito flotante, el carrito entero
    tomarDatosCarrito(datos) {
      const d = datos && datos.cartData;
      if (!d || typeof d !== 'object') return;
      if (Array.isArray(d.items)) {
        this.lineas = lineasDe(d);
      } else if (d.variant_id && d.key && Number.isFinite(Number(d.quantity))) {
        const lineas = new Map(this.lineas || []);
        lineas.set(String(d.variant_id), { clave: d.key, cantidad: Number(d.quantity) });
        this.lineas = lineas;
      } else {
        return;
      }
      this.programar();
    }

    leerCarrito() {
      // Sin caché (ni la del navegador ni la de Safari): siempre el carrito de ahora
      const url = `${(window.routes && window.routes.cart_url) || '/cart'}.js?_=${Date.now()}`;
      const n = (this.pedidoCarrito = (this.pedidoCarrito || 0) + 1);
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then((r) => (r.ok ? r.json() : null))
        .then((c) => {
          // solo vale la respuesta del último pedido (si llegan desordenadas)
          if (!c || n !== this.pedidoCarrito || !this.isConnected) return;
          this.lineas = lineasDe(c);
          this.programar();
        })
        .catch(() => {});
    }

    pintarCantidad(linea, ocupado) {
      if (!this.cajaCantidad) return;
      const ver = !!linea;
      this.cajaCantidad.classList.toggle('sticky-atc__oculto', !ver);
      this.btn.classList.toggle('sticky-atc__oculto', ver);
      if (!ver) return;
      const n = String(linea.cantidad);
      if (this.qtyNum.textContent !== n) this.qtyNum.textContent = n;
      const parado = !!(ocupado || this.cambiandoCantidad);
      this.qtyMenos.disabled = parado;
      this.qtyMas.disabled = parado;
    }

    avisarCantidad(texto) {
      if (!this.qtyAviso) return;
      this.qtyAviso.textContent = texto || '';
      clearTimeout(this.tAvisoQty);
      if (texto) this.tAvisoQty = setTimeout(() => (this.qtyAviso.textContent = ''), 5000);
    }

    // [−]/[+]: cambia la cantidad de ESA línea con /cart/change (como el cajón del tema), actualiza la burbuja del carrito y
    // avisa al tema (cartUpdate): el cajón y la barra de pago móvil se vuelven a pintar solos
    cambiarCantidad(paso) {
      const est = this.leerEstado();
      const linea = this.lineas && est.id ? this.lineas.get(String(est.id)) : null;
      if (!linea || this.cambiandoCantidad) return;
      const nueva = Math.max(0, linea.cantidad + paso);
      this.cambiandoCantidad = true;
      this.avisarCantidad('');
      this.programar();
      const ruta = (window.routes && window.routes.cart_change_url) || '/cart/change';
      const cfg =
        typeof fetchConfig === 'function'
          ? fetchConfig()
          : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const cuerpo = JSON.stringify({
        id: linea.clave,
        quantity: nueva,
        sections: ['cart-icon-bubble'],
        sections_url: window.location.pathname,
      });
      fetch(ruta, { ...cfg, body: cuerpo })
        .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
        .then(({ ok, d }) => {
          if (!ok || !d || d.status || d.errors) {
            this.avisarCantidad((d && (d.description || d.message || d.errors)) || (window.cartStrings && window.cartStrings.error) || '');
            this.leerCarrito();
            return;
          }
          const burbuja = document.getElementById('cart-icon-bubble');
          const html = d.sections && d.sections['cart-icon-bubble'];
          if (burbuja && html) {
            const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
            const destino = burbuja.querySelector('.shopify-section') || burbuja;
            if (nuevo) destino.innerHTML = nuevo.innerHTML;
          }
          const cajon = document.querySelector('cart-drawer');
          if (cajon) cajon.classList.toggle('is-empty', d.item_count === 0);
          this.lineas = lineasDe(d);
          if (hayPubSub() && typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-atc', cartData: d, variantId: est.id });
          }
        })
        .catch(() => {
          this.avisarCantidad((window.cartStrings && window.cartStrings.error) || '');
          this.leerCarrito();
        })
        .finally(() => {
          this.cambiandoCantidad = false;
          this.programar();
        });
    }

    setEtiqueta(t) {
      if (this.etiqueta && this.etiqueta.textContent !== t) this.etiqueta.textContent = t || '';
    }

    pintarTexto(variante, precio) {
      const promo = precio && precio.promo ? `${precio.promo.etiqueta} ${precio.promo.valor}`.trim() : '';
      const clave = `${variante}|${precio ? `${precio.ahora}|${precio.antes || ''}|${promo}` : ''}`;
      if (clave === this.claveTexto) return;
      this.claveTexto = clave;
      // Con 2 o más opciones, cada valor en su línea para que se lean todas (Francisco, 11-oct 17:25Z); el título de la
      // variante de Shopify las separa con « / »
      this.txtVariante.textContent = '';
      const partes = variante ? String(variante).split(' / ').filter(Boolean) : [];
      if (partes.length > 1) {
        partes.forEach((parte) => {
          const linea = document.createElement('span');
          linea.className = 'sticky-atc__variant-linea';
          linea.textContent = parte;
          this.txtVariante.appendChild(linea);
        });
      } else {
        this.txtVariante.textContent = variante;
      }
      this.txtVariante.classList.toggle('sticky-atc__variant--varias', partes.length > 1);
      this.txtVariante.hidden = !variante;
      this.txtPrecio.textContent = '';
      // Solo DOS precios (Francisco, 11-oct 17:20Z): el más alto tachado y el que paga el cliente. Con promoción del tema
      // («Precio final»), el tachado es el precio de antes (o el actual si no hay) y el destacado el final; sin promoción,
      // tachado el de antes y destacado el actual; sin precio de antes ni promoción, solo el actual
      if (precio && precio.ahora) {
        const conPromo = !!(precio.promo && precio.promo.valor);
        const tachado = conPromo ? precio.antes || precio.ahora : precio.antes;
        if (tachado) {
          const etiqueta = document.createElement('span');
          etiqueta.className = 'visually-hidden';
          etiqueta.textContent = `${this.dataset.textRegularPrice || ''} `;
          this.txtPrecio.appendChild(etiqueta);
          const antes = document.createElement('s');
          antes.className = 'sticky-atc__was';
          antes.textContent = tachado;
          this.txtPrecio.append(antes, ' ');
        }
        if (conPromo) {
          const nombre = document.createElement('span');
          nombre.className = 'visually-hidden';
          nombre.textContent = `${precio.promo.etiqueta || ''} `;
          const final = document.createElement('span');
          final.className = 'sticky-atc__promo';
          final.textContent = precio.promo.valor;
          this.txtPrecio.append(nombre, final);
        } else {
          const ahora = document.createElement('span');
          ahora.className = 'sticky-atc__now';
          ahora.textContent = precio.ahora;
          this.txtPrecio.appendChild(ahora);
        }
      }
      this.txtPrecio.hidden = !(precio && precio.ahora);
    }

    // Valor (option value id) elegido ahora mismo en el selector principal
    valorPrincipal() {
      const sel = this.selector;
      if (!sel) return null;
      const radio = sel.querySelector('input[type="radio"]:checked');
      if (radio) return radio.dataset.optionValueId || null;
      const select = sel.querySelector('select');
      const opcion = select && select.selectedOptions && select.selectedOptions[0];
      return opcion ? opcion.dataset.optionValueId || null : null;
    }

    alPulsarOpcion(chip) {
      const id = chip.dataset.optionValueId;
      const sel = this.selector;
      if (!id || !sel) return;
      const radio = sel.querySelector(`input[type="radio"][data-option-value-id="${id}"]`);
      const opcion = sel.querySelector(`option[data-option-value-id="${id}"]`);
      // el cliente acaba de elegir esa opción en la barra
      this.marcarTocada(radio || (opcion && opcion.closest('select')));
      if (radio) {
        if (!radio.checked) {
          this.marcarPendiente();
          // product-info.js enfoca después la opción de la ficha y eso haría saltar
          // la página hasta el selector: se vuelve a donde estaba el cliente
          this.volverA = { y: window.scrollY, chip, hasta: Date.now() + 6000 };
          radio.click(); // el navegador lanza el change como si lo pulsara el cliente
        }
      } else if (opcion) {
        const select = opcion.closest('select');
        if (select && select.selectedOptions[0] !== opcion) {
          this.marcarPendiente();
          select.value = opcion.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      this.programar();
    }

    alPulsarBoton() {
      if (this.btn.getAttribute('aria-disabled') === 'true') return;
      const est = this.leerEstado();
      const modo = this.calcularModo(est);
      if (modo === 'add' && est.comprable && (this.elegido || !this.conVariantes)) {
        this.ultimoEnvio = Date.now();
        // Mismo camino que el cliente al pulsar el botón de la ficha
        est.boton.click();
        return;
      }
      this.irAlSelector();
    }

    irAlSelector() {
      // Lleva a la PRIMERA opción que el cliente aún no ha tocado y resalta TODAS las que faltan
      const sinTocar = this.conVariantes && !this.elegido ? this.opcionesSinTocar() : [];
      const destino =
        sinTocar[0] || this.selector || (this.formulario && this.formulario.closest('product-form')) || this.botonPrincipal;
      if (!destino) return;
      this.desplazarA(destino);
      this.resaltar(sinTocar.length ? sinTocar : [destino]);
      // Accesibilidad: el foco va al GRUPO (no abre nada); con teclado, Tab entra en la opción
      if (destino !== this.botonPrincipal) {
        if (!destino.hasAttribute('tabindex')) destino.setAttribute('tabindex', '-1');
        try {
          destino.focus({ preventScroll: true });
        } catch (e) {
          /* sin foco: el resalte basta */
        }
      }
    }

    // Resalte de cada desplegable (o grupo de botones) que falta con pulsos de borde rojo, como el botón de añadir
    // al carrito, SIN abrirlo: el foco ya no va al <select> (en el móvil lo abría). Con varias opciones sale en TODAS
    // las que faltan (Francisco, 11-oct 19:54Z) y al elegir una se le quita solo a esa. product-info.js redibuja el
    // selector en cada cambio de variante: se recuerda el ÍNDICE del grupo, no el elemento, y en el redibujado se
    // vuelve a poner en las que siguen sin elegir, con la animación en el mismo punto (sin empezar de nuevo)
    resaltar(destinos) {
      this.quitarResalte();
      const grupos = this.grupos();
      const r = { indices: new Set(), sueltos: [], inicio: Date.now() };
      destinos.forEach((d) => {
        const i = grupos.indexOf(d);
        if (i >= 0) r.indices.add(i);
        else r.sueltos.push(d);
      });
      this.resalte = r;
      this.pintarResalte(true);
      this.tResalte = setTimeout(() => this.quitarResalte(), 4600);
      // el redibujado puede sustituir el selector entero: se vigila la columna de la ficha mientras dura
      const columna = this.columnaInfo;
      if (columna && 'MutationObserver' in window) {
        this.moResalte = new MutationObserver(() => {
          if (this.rafResalte) return;
          this.rafResalte = requestAnimationFrame(() => {
            this.rafResalte = 0;
            this.pintarResalte(false);
          });
        });
        this.moResalte.observe(columna, { childList: true, subtree: true });
      }
    }

    marcosResalte() {
      const r = this.resalte;
      if (!r) return [];
      const grupos = this.grupos();
      return [...Array.from(r.indices).map((i) => grupos[i]), ...r.sueltos]
        .filter((el) => el && el.isConnected)
        .map((el) => el.querySelector('.select') || el);
    }

    pintarResalte(reiniciar) {
      const r = this.resalte;
      if (!r) return;
      this.marcosResalte().forEach((marco) => {
        if (reiniciar) {
          marco.classList.remove('sticky-atc-resaltado');
          marco.style.removeProperty('animation-delay');
          void marco.offsetWidth; // reinicia la animación
        } else if (marco.classList.contains('sticky-atc-resaltado')) {
          return;
        } else {
          marco.style.setProperty('animation-delay', `-${Date.now() - r.inicio}ms`);
        }
        marco.classList.add('sticky-atc-resaltado');
      });
    }

    // Sin índice: se quita todo. Con índice: solo el de ese grupo (el cliente acaba de elegirlo)
    quitarResalte(i) {
      const r = this.resalte;
      if (i !== undefined) {
        if (!r || !r.indices.has(i)) return;
        const g = this.grupos()[i];
        const marco = g && (g.querySelector('.select') || g);
        r.indices.delete(i);
        if (marco) {
          marco.classList.remove('sticky-atc-resaltado');
          marco.style.removeProperty('animation-delay');
        }
        if (r.indices.size || r.sueltos.length) return;
      }
      clearTimeout(this.tResalte);
      if (this.moResalte) this.moResalte.disconnect();
      this.moResalte = null;
      document.querySelectorAll('.sticky-atc-resaltado').forEach((m) => {
        m.classList.remove('sticky-atc-resaltado');
        m.style.removeProperty('animation-delay');
      });
      this.resalte = null;
    }

    desplazarA(el) {
      let margen = 16;
      const cabecera = document.querySelector('.section-header');
      if (cabecera) {
        const pos = getComputedStyle(cabecera).position;
        if (pos === 'sticky' || pos === 'fixed') margen += cabecera.offsetHeight;
      }
      const y = el.getBoundingClientRect().top + window.scrollY - margen;
      window.scrollTo({ top: Math.max(0, y), behavior: menosMovimiento() ? 'auto' : 'smooth' });
    }

    // Altura de la barra, hueco bajo ella (barra de pago móvil del tema) y cuánto suben las burbujas
    medir() {
      if (!this.barraLista) return;
      // Con un panel abierto (cajón, aviso, modal, cookies) la barra de pago está oculta:
      // se conserva el último hueco bueno y se vuelve a medir al cerrarse el panel
      if (!document.querySelector(PANELES)) {
        const abajo = this.huecoInferior();
        if (abajo !== this.abajo) {
          this.abajo = abajo;
          this.barra.style.setProperty('--sticky-atc-bottom', `${abajo}px`);
          // Encima de la barra de pago móvil, el margen del iPhone (zona de la raya de inicio) ya lo pone
          // esa barra: si la nuestra también lo suma, en Safari con la barra de herramientas recogida
          // queda un hueco grande bajo el botón (Francisco, 11-oct 15:40Z)
          this.barra.classList.toggle('sticky-atc__bar--elevada', abajo > 0);
        }
      }
      const abajo = this.abajo || 0;
      this.alto = this.barra.offsetHeight;
      // la burbuja conserva su propio margen inferior, ahora sobre la barra (sin sumar nada más: con la barra, el chat queda
      // a la misma distancia de ella que del borde de la pantalla sin ella; Francisco, 11-oct 19:18Z)
      this.elevar = this.alto + abajo;
      if (this.visible) this.marcarFlotantes();
      pintarBody();
    }

    huecoInferior() {
      const b = document.querySelector('.barra-pago-movil');
      if (!b) return 0;
      const cs = getComputedStyle(b);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return 0;
      const r = b.getBoundingClientRect();
      const alto = window.innerHeight;
      if (r.height <= 0 || r.bottom < alto - 2 || r.top < alto / 2) return 0;
      return Math.round(alto - r.top);
    }

    // Solo suben los flotantes que de verdad están abajo
    marcarFlotantes() {
      const abajo = this.abajo || 0;
      document.querySelectorAll(FLOTANTES).forEach((el) => {
        const cs = getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        if (!el.hasAttribute('data-sticky-atc-lift')) {
          const r = el.getBoundingClientRect();
          if (r.height > 0 && r.top > window.innerHeight / 2) el.setAttribute('data-sticky-atc-lift', '');
        }
        // Si el tema YA subió el flotante por encima de la barra de pago móvil (su «bottom» ≥ el hueco de abajo), solo
        // sube lo que mide nuestra barra: así queda a la misma distancia de ella que de la de pago (Francisco, 11-oct
        // 19:18Z: el chat subía la barra de pago dos veces). Si no, el valor general del body (barra + hueco)
        const base = parseFloat(cs.bottom);
        if (abajo > 0 && Number.isFinite(base) && base >= abajo) el.style.setProperty('--sticky-atc-lift', `${this.alto}px`);
        else el.style.removeProperty('--sticky-atc-lift');
      });
    }

    mostrar(si) {
      if (si === this.visible) return;
      this.visible = si;
      if (si) {
        this.medir();
        this.marcarFlotantes();
      }
      this.barra.classList.toggle('is-visible', si);
      pintarBody();
    }

    // =====================================================================
    // «Leer más» de la descripción (APAGADO por defecto). Intenta no plegar datos de
    // compatibilidad, pero puede plegar texto: revisar fichas con compatibilidad antes de encenderlo
    // =====================================================================
    iniciarLeerMas(lineas) {
      const columna = this.columnaInfo;
      const desc = columna && columna.querySelector('.product__description');
      if (!desc || desc.dataset.stickyAtcPliegue) return;
      desc.dataset.stickyAtcPliegue = '1';
      this.desc = desc;
      this.lineas = lineas;
      this.expandido = false;
      if (!desc.id) desc.id = `ProductDescription-${this.sid}`;

      const boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'sticky-atc-leer-mas';
      boton.hidden = true;
      boton.setAttribute('aria-expanded', 'false');
      boton.setAttribute('aria-controls', desc.id);
      boton.textContent = this.dataset.textMore || '';
      desc.insertAdjacentElement('afterend', boton);
      this.botonLeer = boton;
      this.escuchar(boton, 'click', () => this.alternarLeerMas());

      // Si el foco entra en la parte plegada (teclado), se despliega
      this.escuchar(desc, 'focusin', (ev) => {
        if (!desc.classList.contains('is-plegado')) return;
        const r = ev.target.getBoundingClientRect();
        const tope = desc.getBoundingClientRect().top + (this.corte || 0);
        if (r.bottom > tope) this.alternarLeerMas(true);
      });

      const recalcular = () => {
        if (this.rafPliegue) return;
        this.rafPliegue = requestAnimationFrame(() => {
          this.rafPliegue = 0;
          if (this.isConnected) this.aplicarPliegue();
        });
      };
      if ('ResizeObserver' in window) {
        this.roPliegue = new ResizeObserver(recalcular);
        Array.from(desc.querySelectorAll('img, table, iframe, video')).forEach((n) => this.roPliegue.observe(n));
        this.roPliegue.observe(desc);
        this.limpiezas.push(() => this.roPliegue.disconnect());
      }
      this.escuchar(window, 'resize', recalcular);
      this.escuchar(window, 'load', recalcular);
      this.limpiezas.push(() => {
        desc.classList.remove('sticky-atc-plegable', 'is-plegado', 'sticky-atc-sin-difuminado');
        desc.style.removeProperty('--sticky-atc-corte');
        delete desc.dataset.stickyAtcPliegue;
        boton.remove();
      });
      this.aplicarPliegue();
    }

    esProtegido(el) {
      if (el.matches('table') || el.querySelector('table')) return true;
      return COMPAT.test(sinTildes(el.textContent));
    }

    // Devuelve el punto de corte en px, o null si no se debe plegar
    calcularCorte() {
      const desc = this.desc;
      if (!desc.offsetParent && getComputedStyle(desc).position !== 'fixed') return null; // no visible
      const cs = getComputedStyle(desc);
      let lh = parseFloat(cs.lineHeight);
      if (!lh) lh = (parseFloat(cs.fontSize) || 16) * 1.5;
      const limite = lh * this.lineas;
      const total = desc.scrollHeight;
      if (total <= limite + lh * 3) return null; // poco que plegar

      // Baja por envoltorios únicos (<div> que lo envuelve todo)
      let raiz = desc;
      let sueltos = '';
      for (;;) {
        sueltos += Array.from(raiz.childNodes)
          .filter((n) => n.nodeType === 3)
          .map((n) => n.textContent)
          .join(' ');
        if (raiz.children.length === 1 && /^(DIV|SECTION|ARTICLE)$/.test(raiz.children[0].tagName)) {
          raiz = raiz.children[0];
        } else break;
      }
      // Texto suelto con datos de compatibilidad: no se arriesga, no se pliega
      if (COMPAT.test(sinTildes(sueltos))) return null;

      const hijos = Array.from(raiz.children).filter((h) => getComputedStyle(h).display !== 'none');
      const arriba = desc.getBoundingClientRect().top;
      if (!hijos.length) return this.esProtegido(desc) ? null : limite;

      // Protegido: el bloque con señales de compatibilidad (o una tabla) y también el bloque
      // que va justo detrás (p. ej. «Compatibilidad» + párrafo o lista con los modelos)
      const directos = hijos.map((h) => this.esProtegido(h));
      const protegidos = directos.map((d, i) => d || (i > 0 && directos[i - 1]));
      const ultimoProtegido = protegidos.lastIndexOf(true);
      const primero = hijos.findIndex((h) => h.getBoundingClientRect().bottom - arriba > limite);
      if (primero === -1) return null;
      const indice = Math.max(primero, ultimoProtegido + 1);
      if (indice >= hijos.length) return null; // lo que queda es compatibilidad: no se pliega
      const inicio = hijos[indice].getBoundingClientRect().top - arriba;
      let corte = inicio;
      if (indice === primero) {
        // El bloque que pasa del límite no tiene datos de compatibilidad: se corta
        // dentro de él en una línea entera, para enseñar las líneas pedidas
        const lhb = parseFloat(getComputedStyle(hijos[indice]).lineHeight) || lh;
        corte += Math.max(0, Math.floor((limite - corte) / lhb)) * lhb;
      }
      corte = Math.round(corte);
      if (total - corte < lh * 3) return null;
      // Sin difuminado si justo encima del corte hay texto protegido (no se difumina un modelo)
      this.difuminar = !(indice > 0 && protegidos[indice - 1] && corte - inicio < lh * 3);
      return corte;
    }

    aplicarPliegue() {
      const desc = this.desc;
      // Se mide desplegado para no falsear posiciones
      const estaba = desc.classList.contains('is-plegado');
      if (estaba) desc.classList.remove('is-plegado');
      const corte = this.calcularCorte();
      if (corte === null) {
        desc.classList.remove('sticky-atc-plegable');
        desc.style.removeProperty('--sticky-atc-corte');
        this.botonLeer.hidden = true;
        this.corte = 0;
        return;
      }
      this.corte = corte;
      desc.classList.toggle('sticky-atc-sin-difuminado', this.difuminar === false);
      desc.classList.add('sticky-atc-plegable');
      desc.style.setProperty('--sticky-atc-corte', `${corte}px`);
      this.botonLeer.hidden = false;
      if (!this.expandido) desc.classList.add('is-plegado');
    }

    alternarLeerMas(abrir) {
      this.expandido = typeof abrir === 'boolean' ? abrir : !this.expandido;
      this.desc.classList.toggle('is-plegado', !this.expandido);
      this.botonLeer.setAttribute('aria-expanded', String(this.expandido));
      this.botonLeer.textContent = this.expandido ? this.dataset.textLess || '' : this.dataset.textMore || '';
      if (!this.expandido) {
        const r = this.botonLeer.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) {
          this.botonLeer.scrollIntoView({ block: 'center', behavior: menosMovimiento() ? 'auto' : 'smooth' });
        }
      }
    }
  }

  customElements.define('sticky-atc', StickyAtc);
})();
